import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { NavigationService } from '../services/navigation.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanLoad {
  constructor(
    private user$: UserService,
    private navigation$: NavigationService,
    private router: Router
  ) {
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable(subscriber => {
      this.user$.user$.subscribe(user => {
        this.navigation$.get().subscribe(result => {
          const nav = result.default.find(f => f.link.indexOf(route.path) !== -1);
          if (nav && nav.meta.isAdmin && (nav.meta.isAdmin && !user.isAdmin)) {
            this.router.navigateByUrl('/');
          }
          subscriber.next(true);
        });
      });
    });
  }
}
